import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useHasPermission } from '@/hooks/useHasPermission';

interface RequirePermissionProps {
  module: string;
  action: string;
  children: React.ReactNode;
  /** Where to send the user if they lack the permission. Defaults to the dashboard. */
  redirectTo?: string;
}

/**
 * Route-level permission guard. The nav/sidebar already hide links a role
 * can't use, but nothing previously stopped someone from reaching a page by
 * typing the URL directly -- this closes that gap.
 */
export function RequirePermission({ module, action, children, redirectTo = '/dashboard' }: RequirePermissionProps) {
  const { loading } = useAuth();
  const allowed = useHasPermission(module, action);

  if (loading) {
    return null;
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

export default RequirePermission;
